export const T = {
  en_GB: {
    title: "What changes",
    unavailable: "The client counts could not be loaded.",
    retry: "Retry",
  },
  nb_NO: {
    title: "Hva som endres",
    unavailable: "Kunne ikke hente antall kunder.",
    retry: "Prøv igjen",
  },
} as const;
